import useUpgradeWarning from '@apps/www/src/www/hooks/useUpgradeWarning';
import SVUpgradeWarningModal from '@apps/www/src/www/modals/SVUpgradeWarningModal';
import SVModal from '@pkgs/shared-client/components/SVModal';
import { useEffect } from 'react';

const SVUpgradeWarningContainer = () => {
	const upgradeWarning = useUpgradeWarning();

	useEffect(() => {
		if (upgradeWarning) {
			SVModal.open(SVUpgradeWarningModal, {
				reason: upgradeWarning.reason,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return null;
};

export default SVUpgradeWarningContainer;
